import styled from 'styled-components';
import DepositWithdrawSteps from '../deposit-withdraw-steps/DepositWithrdawSteps';
export const DepositFiatStepsWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 5rem;
  ${({ theme }) => theme.media.tablet `
    gap: 13rem;
  `}
`;
export const CustomDepositWithdrawSteps = styled(DepositWithdrawSteps) `
  .bankwire-image-container {
    ${({ theme }) => theme.media.tablet `
    top: -8rem;
  `}
  }
`;
//# sourceMappingURL=styles.js.map